import React, { useState, useEffect, useContext, useMemo } from "react";
import EmailReport from "../../components/worklog/EmailReport";
import { WorkLogCard } from "../../components/worklog/WorkLogCard";
import WorkLogToolbar from "../../components/worklog/WorkLogToolbar";
import AppContext from "../../context/AppContext";
import { fetchWorkLogs } from "../../service/Worklog";
import { Spinner } from "../../Spinner";
import translations from "../../components/common/Translations";
import ReactSelector from "../../components/common/CommonReactSelector";
import { components } from 'react-select';
import { getActivityListByProjectId } from "../../service/User";

const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};

const WorkLogMain = () => {
  const [open, setOpen] = useState(false);
  const [todos, setTodos] = useState([]);
  const [inProgress, setInProgress] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [selectedPriority, setSelectedPriority] = useState("Low_Priority");
  const [todoTotalCount, setTodoTotalCount] = useState(0);
  const [inProgressTotalCount, setInProgressTotalCount] = useState(0);
  const [completedTotalCount, setCompletedTotalCount] = useState(0);
  const { workflowId, selectedOrgId, setSelectedOrgId, langMode, projectId, activityId, updateActivityId, activityLoader , setWorkflowId} =
    useContext(AppContext);
  const { theme } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [activity,setActivity] = useState()
  const formatDate = (date, time) => {
    return date.toISOString().split("T")[0] + time;
  };
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const defaultFromDate = formatDate(yesterday, "T00:00:00");
  const defaultToDate = formatDate(today, "T23:59:59");
  const [dates, setDates] = useState({
    fromDate: defaultFromDate,
    toDate: defaultToDate,
  });
  const [searchAccountNumber, setSearchAccountNumber] = useState("");

  const fetchData = async (page, size, reset = false) => {
    setIsLoading(true);
    try {
      const data = await fetchWorkLogs({
        page,
        size,
        activityId,
        selectedOrgId,
        selectedPriority,
        dates,
        accountNo: searchAccountNumber,
      });
      const {
        toDo,
        inProgress,
        completed,
        toDoTotalCount,
        inProgressTotalCount,
        completedTotalCount,
      } = data;
      if (
        Array.isArray(toDo) &&
        Array.isArray(inProgress) &&
        Array.isArray(completed)
      ) {
        if (reset) {
          setTodos(toDo);
          setInProgress(inProgress);
          setCompleted(completed);
        } else {
          setTodos((prevTodos) =>
            Array.isArray(prevTodos)
              ? [...new Set([...prevTodos, ...toDo])]
              : [...toDo]
          );
          setInProgress((prevInProgress) =>
            Array.isArray(prevInProgress)
              ? [...new Set([...prevInProgress, ...inProgress])]
              : [...inProgress]
          );
          setCompleted((prevCompleted) =>
            Array.isArray(prevCompleted)
              ? [...new Set([...prevCompleted, ...completed])]
              : [...completed]
          );
        }
      } else {
        console.error(
          "Invalid data format: toDo, inProgress, or completed is not an array"
        );
      }
      setTodoTotalCount(toDoTotalCount);
      setInProgressTotalCount(inProgressTotalCount);
      setCompletedTotalCount(completedTotalCount);
    } catch (error) {
      console.error("Error fetching work logs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setPage(0);
    setSize(10);
    setTodos([]);
    setInProgress([]);
    setCompleted([]);
    if(activityId){
      fetchData(0, 10, true);
    }
  }, [selectedOrgId, selectedPriority, activityId, dates, searchAccountNumber]);

  useEffect(() => {
    if (page === 0) return;
    fetchData(page, size);
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 2
      ) {
        setPage((prevPage) => prevPage + 1);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    const fetchActivityList = async () => {

      try {
        const data = await getActivityListByProjectId(projectId);
        setActivity(data)
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };
    if (projectId) {
      fetchActivityList(); // Trigger the project fetch whenever `userInfo.organization` changes
    }
  }, [projectId]);

  const options = useMemo(() => {
    return (activity || [])
      .filter(Boolean)
      .map((item) => ({
        value: item.workflowId,
        label: item.workflowName,
      }));
  }, [activity]);

  const defaultActivityValue = useMemo(() => {
    if (projectId !== null && activityId && activity?.length) {
      const activityIdList = typeof activityId === 'string'
        ? activityId.split(',')
        : Array.isArray(activityId)
          ? activityId.map(id => id.toString())
          : [activityId?.toString()];

      return (activity || [])
        .filter((org) => activityIdList.includes(org.workflowId?.toString()))
        .map((dept) => ({
          value: dept.workflowId,
          label: dept.workflowName,
        }));
    }
    return [];
  }, [projectId, activityId, activity]);

  useEffect(() => {
    if (defaultActivityValue && defaultActivityValue.length > 0) {
      const valueString = defaultActivityValue.map(item => item.value).join(',');
      setWorkflowId(valueString);
      updateActivityId(valueString);
      localStorage.setItem("activityId", valueString);

    }
  }, [defaultActivityValue]);

  const handleActivityChange = (selectedValue) => {
    updateActivityId(selectedValue.value)
  }

  return (
    <div>
      {/* {isLoading && (
        <Spinner/>
      )} */}
      <div className="w-full py-2">
        <div className="flex justify-between">
        <h4 className={`uppercase ml-[10px] font-semibold whitespace-nowrap text-gray-800 ${
            theme === "dark"
              ? "dark-mode "
              : theme === "high-contrast"
              ? "high-contrast  "
              : ""
          }`}>
          {translations[langMode].worklog}
        </h4>
        {/* <div className="max-w-[212px] w-full">
        {activityLoader ?  <Spinner/> : <ReactSelector
            options={projectId !== null ? options : []}
            components={Placeholder}
            placeholder={(projectId !== null || activityId) ? (options.length > 0 )? translations[langMode].select : translations[langMode].noactivity  : translations[langMode].noactivity}
            onChange={handleActivityChange}
            height="38px"
            value={defaultActivityValue}
          />}
          </div> */}
        </div>
        <div
          className={` w-full ${
            theme === "dark"
              ? "dark-mode"
              : theme === "high-contrast"
              ? "high-contrast"
              : ""
          } px-5 py-1 bg-white`}>
          <WorkLogToolbar
            setOpen={setOpen}
            selectedOrgId={selectedOrgId}
            setSelectedOrgId={setSelectedOrgId}
            setSelectedPriority={setSelectedPriority}
            setDates={setDates}
            setSearchAccountNumber={setSearchAccountNumber}/>
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-12 py-5 overflow-y-auto">
            <div className="border-dashed border-2 border-blue-700 px-5 py-5">
              <h6 className="text-sm text-blue-700 font-semibold">
                {translations[langMode].todo} ({todoTotalCount})
              </h6>
              <WorkLogCard workLogs={todos} />
            </div>
            <div className="border-dashed border-2 border-red-600 px-5 py-5">
              <h6 className="text-sm text-red-600 font-semibold">
                {translations[langMode].progress}({inProgressTotalCount})
              </h6>
              <WorkLogCard workLogs={inProgress} />
            </div>
            <div className="border-dashed border-2 border-green-500 px-5 py-5">
              <h6 className="text-sm text-green-500 font-semibold">
                {translations[langMode].completed} ({completedTotalCount})
              </h6>
              <WorkLogCard workLogs={completed} />
            </div>
          </div> */}
          {isLoading && (
            <div className="text-center py-4">
              <p>{translations[langMode].loading}</p>
            </div>
          )}
          {/* {!isLoading && (
            <div className="text-center py-4">
              <p>{translations[langMode].nomore}</p>
            </div>
          )} */}
        </div>
      </div>

      <EmailReport open={open} setOpen={setOpen} />
    </div>
  );
};

export default WorkLogMain;
